import { Action } from "redux"

export const INITIALIZE = "RESOURCEHEADER_INITIALIZE"
export const INCREASE_ATTACHMENTS_COUNT =
    "RESOURCEHEADER_INCREASE_ATTACHMENTS_COUNT"
export const INCREASE_COMMENTS_COUNT = "RESOURCEHEADER_INCREASE_COMMENTS_COUNT"

export const REFRESH_STATUS = "RESOURCEHEADER_REFRESH_STATUS"
export const REFRESH_TITLE = "RESOURCEHEADER_REFRESH_TITLE"
export const REFRESH_CONCEPT_BREADCRUMB =
    "RESOURCEHEADER_REFRESH_CONCEPT_BREADCRUMB"
export const UPDATE_UNSYNC_TITLE = "RESOURCEHEADER_UPDATE_UNSYNC_TITLE"
export const UPDATE_TITLE = "RESOURCEHEADER_UPDATE_TITLE"
export const UPDATE_SHARESUCCESSMESSAGE_VISIBILITY =
    "RESOURCEHEADER_UPDATE_SHARESUCCESSMESSAGE_VISIBILITY"

export const EXECUTE_CALL_BUTTON = "RESOURCEHEADER_EXECUTE_CALL_BUTTON"
export const REGISTER_BUTTON_CALLBACK =
    "RESOURCEHEADER_REGISTER_BUTTON_CALLBACK"
export const TOGGLE_BUTTON_SCRIPTS_VISIBILITY =
    "RESOURCEHEADER_TOGGLE_BUTTON_SCRIPTS_VISIBILITY"
export const UPDATE_BUTTON_LOADING = "RESOURCEHEADER_UPDATE_BUTTON_LOADING"
export const UPDATE_BUTTON_VISIBILITY =
    "RESOURCEHEADER_UPDATE_BUTTON_VISIBILITY"

export const RECEIVE_LIST_VIEWS = "RESOURCEHEADER_RECEIVE_LIST_VIEWS"
export const REQUEST_LIST_VIEWS = "RESOURCEHEADER_REQUEST_LIST_VIEWS"
export const UPDATE_SELECTED_LIST_VIEW =
    "RESOURCEHEADER_UPDATE_SELECTED_LIST_VIEW"

export const SET_BOOKMARK_UUID = "RESOURCEHEADER_SET_BOOKMARK_UUID"

export interface Initialize extends Action {
    props: Partial<ResourceHeader.Header>
    activePanel: string
    buttonsArray: Omit<ContextMenu.Button, "isLoading" | "uuid">[]
    breadcrumbsArray: ResourceHeader.Breadcrumb[]
}

export interface ToggleButtonScriptsVisibility extends Action {
    scriptIds: number[]
}

export interface IncreaseCount extends Action {
    count: number
}

export interface UpdateTitle extends Action {
    title: string
}

export interface RefreshTitle extends Action {
    fieldValue: Partial<ResourceHeader.FieldValue>
}

export interface RefreshStatus extends Action {
    statusLabel: string
}

export interface RefreshConceptBreadcrumb extends Action {
    workspaceId: number
    workspaceName: string
    conceptId: number
    conceptName: string
}

export interface RegisterButton extends Action {
    actionId: string
    callback: ContextMenu.HeaderButtonCallback
}

export interface UpdateButtonVisibility extends Action {
    id: string
    visibility: boolean
}

export interface UpdateButtonLoading extends Action {
    buttonUuid: string
    isLoading: boolean
}

export interface ExecuteCallButton extends Action {
    button: ContextMenu.CallButton
}

export interface UpdateVisibility extends Action {
    visibility: boolean
}

export interface RequestListViews extends Action {
    selectionFilterId?: string
    viewType?: number
}

export interface ReceiveListViews extends Action {
    Values: ResourceHeader.View[]
}

export interface UpdateSelectedListView extends Action {
    selectedView: ResourceHeader.View
}

export interface InitializeBookmarkButtonId extends Action {
    bookmarkButtonId: string
}

export const initialize = (
    props: Partial<ResourceHeader.Header>,
    activePanel: string,
    buttonsArray: Omit<ContextMenu.Button, "isLoading" | "uuid">[],
    breadcrumbsArray: ResourceHeader.Breadcrumb[],
): Initialize => ({
    type: INITIALIZE,
    props,
    activePanel,
    buttonsArray,
    breadcrumbsArray,
})

export const toggleButtonScriptsVisibility = (
    scriptIds: number[],
): ToggleButtonScriptsVisibility => ({
    type: TOGGLE_BUTTON_SCRIPTS_VISIBILITY,
    scriptIds,
})

export const increaseAttachmentsCount = (count: number): IncreaseCount => ({
    type: INCREASE_ATTACHMENTS_COUNT,
    count,
})

export const increaseCommentsCount = (count: number): IncreaseCount => ({
    type: INCREASE_COMMENTS_COUNT,
    count,
})

export const updateTitle = (title: string): UpdateTitle => ({
    type: UPDATE_TITLE,
    title,
})

export const updateUnsyncTitle = (title: string): UpdateTitle => ({
    type: UPDATE_UNSYNC_TITLE,
    title,
})
export const refreshTitle = (
    fieldValue: Partial<ResourceHeader.FieldValue>,
): RefreshTitle => ({ type: REFRESH_TITLE, fieldValue })

export const refreshStatus = (statusLabel: string): RefreshStatus => ({
    type: REFRESH_STATUS,
    statusLabel,
})

export const refreshConceptBreadcrumb = (
    workspaceId: number,
    workspaceName: string,
    conceptId: number,
    conceptName: string,
): RefreshConceptBreadcrumb => ({
    type: REFRESH_CONCEPT_BREADCRUMB,
    workspaceId,
    workspaceName,
    conceptId,
    conceptName,
})

export const updateShareSuccessMessageVisibility = (
    visibility: boolean,
): UpdateVisibility => ({
    type: UPDATE_SHARESUCCESSMESSAGE_VISIBILITY,
    visibility,
})

export const registerButtonCallback = (
    actionId: string,
    callback: ContextMenu.HeaderButtonCallback,
): RegisterButton => ({ type: REGISTER_BUTTON_CALLBACK, actionId, callback })

export const updateButtonVisibility = (
    id: string,
    visibility: boolean,
): UpdateButtonVisibility => ({
    type: UPDATE_BUTTON_VISIBILITY,
    id,
    visibility,
})

export const updateButtonLoading = (
    buttonUuid: string,
    isLoading: boolean,
): UpdateButtonLoading => ({
    type: UPDATE_BUTTON_LOADING,
    buttonUuid,
    isLoading,
})

export const executeCallButton = (
    button: ContextMenu.CallButton,
): ExecuteCallButton => ({ type: EXECUTE_CALL_BUTTON, button })

export const requestListViews = (
    selectionFilterId?: string,
    viewType?: number,
): RequestListViews => ({
    type: REQUEST_LIST_VIEWS,
    selectionFilterId,
    viewType,
})

export const receiveListViews = (
    Values: ResourceHeader.View[],
): ReceiveListViews => ({ type: RECEIVE_LIST_VIEWS, Values })

export const updateSelectedListView = (
    selectedView: ResourceHeader.View,
): UpdateSelectedListView => ({ type: UPDATE_SELECTED_LIST_VIEW, selectedView })

export const initializeBookmarkButtonId = (
    bookmarkButtonId: string,
): InitializeBookmarkButtonId => ({ type: SET_BOOKMARK_UUID, bookmarkButtonId })

export const mapDispatchToProps = {
    updateTitle,
    updateUnsyncTitle,
    updateShareSuccessMessageVisibility,
    registerButtonCallback,
    updateButtonVisibility,
    toggleButtonScriptsVisibility,
    updateButtonLoading,
    executeCallButton,
    requestListViews,
    receiveListViews,
    updateSelectedListView,
    initializeBookmarkButtonId,
}

export type DispatchProps = typeof mapDispatchToProps
